"use strict";

exports.__esModule = true;
exports.SIZES = exports.CLOSE_BUTTON_DATA_TEST = void 0;
let SIZES = /*#__PURE__*/function (SIZES) {
  SIZES["EXTRASMALL"] = "extraSmall";
  SIZES["SMALL"] = "small";
  SIZES["NORMAL"] = "normal";
  SIZES["LARGE"] = "large";
  SIZES["EXTRALARGE"] = "extraLarge";
  return SIZES;
}({});
exports.SIZES = SIZES;
const CLOSE_BUTTON_DATA_TEST = "ModalCloseButton";
exports.CLOSE_BUTTON_DATA_TEST = CLOSE_BUTTON_DATA_TEST;